import React, { useState } from 'react';
import { Bell, Search, Settings, HelpCircle, User, LogOut, Mail, Menu, X, ChevronDown } from 'lucide-react';
export const Header = () => {
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const toggleNotifications = () => {
    setIsNotificationsOpen(!isNotificationsOpen);
    if (isProfileOpen) setIsProfileOpen(false);
  };
  const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
    if (isNotificationsOpen) setIsNotificationsOpen(false);
  };
  const handleSearch = e => {
    e.preventDefault();
    // Implement search functionality
    console.log('Searching for:', searchQuery);
  };
  return <header className="bg-white border-b border-gray-200 z-30" data-id="element-683">
      <div className="px-4 sm:px-6 lg:px-8" data-id="element-684">
        <div className="flex items-center justify-between h-16" data-id="element-685">
          {/* Logo and mobile menu button */}
          <div className="flex items-center" data-id="element-686">
            <button className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-687">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-688" /> : <Menu className="h-6 w-6" data-id="element-689" />}
            </button>
            <div className="flex-shrink-0 flex items-center" data-id="element-690">
              <div className="h-8 w-8 bg-blue-600 rounded-md flex items-center justify-center text-white font-bold mr-2" data-id="element-691">
                GM
              </div>
              <span className="text-lg font-semibold text-gray-800 hidden md:block" data-id="element-692">
                GM Office Portal
              </span>
            </div>
          </div>
          {/* Search bar */}
          <div className="flex-1 max-w-lg mx-4 hidden md:block" data-id="element-693">
            <form onSubmit={handleSearch} className="relative" data-id="element-694">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-695" />
              <input type="text" placeholder="Search documents, workflows, users..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-696" />
            </form>
          </div>
          {/* Right side icons */}
          <div className="flex items-center space-x-1 sm:space-x-3" data-id="element-697">
            <button className="p-2 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" data-id="element-698">
              <HelpCircle className="h-5 w-5" data-id="element-699" />
            </button>
            <button className="p-2 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" data-id="element-700">
              <Settings className="h-5 w-5" data-id="element-701" />
            </button>
            <div className="relative" data-id="element-702">
              <button className="p-2 rounded-full text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none" onClick={toggleNotifications} data-id="element-703">
                <Bell className="h-5 w-5" data-id="element-704" />
                <span className="absolute top-0 right-0 h-4 w-4 bg-red-500 rounded-full border-2 border-white text-xs text-white flex items-center justify-center" data-id="element-705">
                  3
                </span>
              </button>
              {isNotificationsOpen && <NotificationsDropdown data-id="element-706" />}
            </div>
            <div className="relative" data-id="element-707">
              <button className="flex items-center space-x-2 p-1 rounded-full focus:outline-none" onClick={toggleProfile} data-id="element-708">
                <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-sm font-medium text-blue-800" data-id="element-709">
                  JA
                </div>
                <ChevronDown className="h-4 w-4 text-gray-500 hidden sm:block" data-id="element-710" />
              </button>
              {isProfileOpen && <ProfileDropdown data-id="element-711" />}
            </div>
          </div>
        </div>
      </div>
      {/* Mobile search - visible on small screens */}
      <div className="md:hidden px-4 pb-3" data-id="element-712">
        <form onSubmit={handleSearch} className="relative" data-id="element-713">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-714" />
          <input type="text" placeholder="Search..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-715" />
        </form>
      </div>
    </header>;
};
const NotificationsDropdown = () => {
  const notifications = [{
    id: 1,
    title: 'New document uploaded',
    description: 'Budget Proposal 2023 has been uploaded',
    time: '10 minutes ago',
    read: false
  }, {
    id: 2,
    title: 'Workflow step completed',
    description: 'Fatima approved the Annual Budget document',
    time: '1 hour ago',
    read: false
  }, {
    id: 3,
    title: 'Meeting reminder',
    description: 'Department meeting in 30 minutes',
    time: '2 hours ago',
    read: false
  }, {
    id: 4,
    title: 'Document comment',
    description: 'Mohammed commented on Project Proposal',
    time: 'Yesterday',
    read: true
  }, {
    id: 5,
    title: 'System update',
    description: 'System maintenance scheduled for tonight',
    time: 'Yesterday',
    read: true
  }];
  return <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200" data-id="element-716">
      <div className="px-4 py-2 border-b border-gray-200" data-id="element-717">
        <div className="flex justify-between items-center" data-id="element-718">
          <h3 className="text-sm font-semibold text-gray-700" data-id="element-719">Notifications</h3>
          <span className="text-xs text-blue-600 cursor-pointer hover:text-blue-800" data-id="element-720">
            Mark all as read
          </span>
        </div>
      </div>
      <div className="max-h-96 overflow-y-auto" data-id="element-721">
        {notifications.map(notification => <div key={notification.id} className={`px-4 py-3 hover:bg-gray-50 cursor-pointer ${!notification.read ? 'bg-blue-50' : ''}`} data-id="element-722">
            <div className="flex justify-between" data-id="element-723">
              <p className="text-sm font-medium text-gray-900" data-id="element-724">
                {notification.title}
              </p>
              <p className="text-xs text-gray-500" data-id="element-725">{notification.time}</p>
            </div>
            <p className="text-xs text-gray-600 mt-1" data-id="element-726">
              {notification.description}
            </p>
          </div>)}
      </div>
      <div className="px-4 py-2 border-t border-gray-200" data-id="element-727">
        <button className="text-sm text-blue-600 hover:text-blue-800 w-full text-center" data-id="element-728">
          View all notifications
        </button>
      </div>
    </div>;
};
const ProfileDropdown = () => {
  const user = {
    name: 'Jasim Alawadhi',
    email: 'jasim.alawadhi@gmo.gov.ae',
    role: 'General Manager'
  };
  return <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200" data-id="element-729">
      <div className="px-4 py-3 border-b border-gray-200" data-id="element-730">
        <div className="flex items-center" data-id="element-731">
          <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-sm font-medium text-blue-800 mr-3" data-id="element-732">
            JA
          </div>
          <div data-id="element-733">
            <p className="text-sm font-medium text-gray-900" data-id="element-734">{user.name}</p>
            <p className="text-xs text-gray-500" data-id="element-735">{user.email}</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-736">{user.role}</p>
          </div>
        </div>
      </div>
      <div className="py-1" data-id="element-737">
        <a href="#profile" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-738">
          <User className="h-4 w-4 mr-3 text-gray-500" data-id="element-739" />
          Your Profile
        </a>
        <a href="#settings" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-740">
          <Settings className="h-4 w-4 mr-3 text-gray-500" data-id="element-741" />
          Settings
        </a>
        <a href="#messages" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-742">
          <Mail className="h-4 w-4 mr-3 text-gray-500" data-id="element-743" />
          Messages
        </a>
      </div>
      <div className="py-1 border-t border-gray-200" data-id="element-744">
        <a href="#logout" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-745">
          <LogOut className="h-4 w-4 mr-3 text-gray-500" data-id="element-746" />
          Sign out
        </a>
      </div>
    </div>;
};